import React from 'react';
import cn from 'classnames';

import Typography, {
  TypographyColor,
  TypographySize,
  TypographyWeight
} from 'widget/shared/ui/Typography';
import { TypographyTag } from 'widget/shared/ui/Typography/types';
import { Spinner, SpinnerSize } from 'widget/shared/ui/Spinner';

import styles from './Button.module.scss';

export type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
};

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  type = 'button',
  className
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      className={cn(
        styles['button'],
        fullWidth && styles['button_full'],
        isDisabled && styles['button_disabled'],
        className
      )}
      onClick={onClick}
      disabled={isDisabled}
      type={type}
    >
      {loading && (
        <Spinner size={SpinnerSize.xs} className={styles['button__spinner']} />
      )}
      {children && (
        <Typography
          size={TypographySize.s}
          weight={TypographyWeight.medium}
          color={TypographyColor.accent}
          tag={TypographyTag.div}
        >
          {children}
        </Typography>
      )}
    </button>
  );
};

export default React.memo(Button);
